import { format } from "date-fns";
import { enUS } from "date-fns/locale";
import { v4 as uuidv4 } from "uuid";
export class ProjectImpedimentDetailViewModel {
    constructor() {
        this.id = uuidv4();
        this.impediments = "";
        this.createdBy = uuidv4();
        this.creatorName = "";
        this.resolverName = "";
        this.projectId = "";
        this.resolvedBy = "";
        this.resolvedOn = null;
        this.mediaFileId = "";
        this.profileImageUrl = "";
        this.createdOnAsString = "";
        this.resolvedOnAsString = "";
        this.isResolved = false;
        this.isDeletable = false;
    }
    formatCreatedTime() {
        const parsedDate = new Date(this.createdOn);
        const formattedDate = format(parsedDate, "d MMM yyyy", { locale: enUS });
        return formattedDate;
    }
    formatResolvedTime() {
        if (this.resolvedOn != null) {
            const parsedDate = new Date(this.createdOn);
            const formattedDate = format(parsedDate, "d MMM yyyy", { locale: enUS });
            return formattedDate;
        }
        return null;
    }
}
export default class ProjectImpedimentDetailView extends ProjectImpedimentDetailViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
